'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $(function () {
        $('[data-scroll-pane]', this).mCustomScrollbar({
            advanced: {
                updateOnContentResize: true
            },
            scrollButtons: {
                enable: false
            },
            scrollEasing: 'linear',
            scrollInertia: 150,
            mouseWheelPixels: "100"
        });
        $("#ean-filter", this).keypress(function (event) {
            if (event.which == 13) {
                $("#ean-filter-button").click();
            }
        });
    });
};

var $ = require("jquery");

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/productSearch.js
// module id = 946
// module chunks = 0